var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table-cell',{staticClass:"total-cell"},[_c('base-container',{attrs:{"vertical-center":"","horizontal-center":""}},[_c('base-text',{attrs:{"value":_vm.value,"bold":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }